import Vue from 'vue';
import App from './App.vue';
import router from './router';
import http from './http';
import VueGtag from 'vue-gtag';
import emitter from './util/emitter';
import moment from 'moment';
import { v1 as uuidv1 } from 'uuid';
import store from './store';

// style sheet
import './assets/scss/_style.scss';

// icons
import '@mdi/font/css/materialdesignicons.css'; // Ensure you are using css-loader

Vue.config.productionTip = false;

const isIframe = () => {
  try {
    return window.self !== window.top;
  } catch (error) {
    return true;
  }
};

// User UUID Setting
try {
  if (!window.localStorage.getItem(process.env.VUE_APP_UUID_KEY)) {
    const uuid = uuidv1();
    window.localStorage.setItem(process.env.VUE_APP_UUID_KEY, uuid);
  }
  if (window.localStorage.getItem(process.env.VUE_APP_LOGIN_ID)) {
    window.localStorage.removeItem(process.env.VUE_APP_LOGIN_ID);
  }
} catch (DOMException) {
  if (DOMException.message === "Failed to read the 'localStorage' property from 'Window': Access is denied for this document.") {
    alert('챗봇 작동 불가 : 브라우저 설정> 쿠키 허용을 선택해주세요.');
  }
}

Vue.use(VueGtag, {
  config: {
    id: process.env.VUE_APP_GOOGLE_ANALYTICS
  }
});

Vue.config.productionTip = false;

Vue.prototype.$http = http.apiClient;
Vue.prototype.$moment = moment;
Vue.prototype.$mitt = emitter;
Vue.prototype.$isIframe = isIframe();
Vue.prototype.$isSeller = process.env.VUE_APP_TARGET === 'sellergate';

window.$mitt = emitter;

// 화면 로딩시 SDK 오픈 요청
// console.log('#####isIframe() ==== ', isIframe());
// window.parent.postMessage({
//   messageType: 'OPEN_CHATROOM'
// }, '*')
console.log('cloudgate v', process.env.VUE_APP_VERSION);

const vm = new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app');

window.app = vm;
